const USER_CHANNEL = 'user-auth-channel';

type BroadcastMessage = { type: 'invalidate-user-query' };

export const broadcastInvalidateUserQuery = (): void => {
  const channel = new BroadcastChannel(USER_CHANNEL);
  channel.postMessage({ type: 'invalidate-user-query' } satisfies BroadcastMessage);
  channel.close();
};

export const onInvalidateUserQuery = (callback: () => void): (() => void) => {
  const channel = new BroadcastChannel(USER_CHANNEL);
  channel.onmessage = (event: MessageEvent<BroadcastMessage>) => {
    if (event.data.type === 'invalidate-user-query') {
      callback();
    }
  };
  return () => channel.close();
};
